import React from "react";
import Button from "../../Buttons/button";

function ConfirmModal({
  setPopup,
  setConfirmDelete = () => {},
}) {
  const handleConfirm = () => {
    setConfirmDelete(true);
    setPopup(false)
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="transform rounded-[12px] md:rounded-2xl bg-[#363D50] p-3 md:p-6 md:w-[365px] transition-all">
        {/* Close Icon */}
        <div className="flex justify-end">
          <svg
            className="cursor-pointer"
            onClick={() => { setPopup(false) }}
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.41 12L17.71 7.71C17.9 7.52 18.004 7.27 18.004 7C18.004 6.73 17.9 6.48 17.71 6.29C17.52 6.1 17.266 5.996 16.999 5.996C16.733 5.996 16.478 6.1 16.29 6.29L12 10.59 7.71 6.29C7.521 6.1 7.266 5.996 6.999 5.996C6.733 5.996 6.478 6.1 6.29 6.29C6.102 6.48 5.996 6.73 5.996 7C5.996 7.27 6.102 7.52 6.29 7.71L10.59 12 6.29 16.29C6.196 16.38 6.122 16.49 6.071 16.61C6.02 16.737 5.994 16.868 5.994 17C5.994 17.132 6.02 17.263 6.071 17.385C6.122 17.506 6.196 17.617 6.29 17.71C6.383 17.804 6.494 17.878 6.615 17.929C6.737 17.98 6.868 18.006 6.999 18.006C7.132 18.006 7.263 17.98 7.384 17.929C7.506 17.878 7.617 17.804 7.71 17.71L12 13.41 16.29 17.71C16.383 17.804 16.494 17.878 16.615 17.929C16.737 17.98 16.868 18.006 16.999 18.006C17.132 18.006 17.263 17.98 17.384 17.929C17.506 17.878 17.617 17.804 17.71 17.71C17.804 17.617 17.878 17.506 17.929 17.385C17.98 17.263 18.006 17.132 18.006 17C18.006 16.868 17.98 16.737 17.929 16.615C17.878 16.493 17.804 16.383 17.71 16.29L13.41 12Z"
              fill="white"
            />
          </svg>
        </div>

        {/* Content */}
        <div className="flex flex-col gap-2 text-center mt-2">
          <h2 className="text-primary text-[24px] font-semibold">Are you sure?</h2>
        </div>

        {/* Footer */}
       <div className=" flex flex-col gap-[32px] mt-3 md:mt-6">
        <div className="flex flex-col md:flex-row justify-center items-center gap-[16px]">
          <Button
            onClick={() => {
              setPopup(false);
            }}
            className={"!w-[150px] btnHover"}
            position={"center"}
            outlined={true}
            secondary={true}
          >
            NO
          </Button>
          <Button
            onClick={handleConfirm}
            className={"!w-[150px] btnHover"}
            fill={true}
            position={"center"}
          >
            YES
          </Button>
        </div>
          </div>
      </div>
    </div>
  );
}

export default ConfirmModal;

